import { create } from "zustand";

interface IndicatorLoggerState {
  buildLines: string[];
  loggerLines: string[];
  terminalLines: string[];
  isCompiling: boolean;
  runtimeReady: boolean;
  runtimeMessage: string | null;
  appendBuild: (line: string) => void;
  appendLogger: (line: string) => void;
  appendTerminal: (line: string) => void;
  clearBuild: () => void;
  clearLogger: () => void;
  clearTerminal: () => void;
  setCompiling: (v: boolean) => void;
  setRuntimeReady: (v: boolean) => void;
  setRuntimeMessage: (msg: string | null) => void;
  resetSession: () => void;
}

export const useIndicatorLoggerStore = create<IndicatorLoggerState>((set) => ({
  buildLines: [],
  loggerLines: [],
  terminalLines: [],
  isCompiling: false,
  runtimeReady: false,
  runtimeMessage: null,
  appendBuild: (line) =>
    set((s) => ({ buildLines: [...s.buildLines, line] })),
  appendLogger: (line) =>
    set((s) => ({
      loggerLines: [
        ...s.loggerLines,
        `[${new Date().toLocaleTimeString()}] ${line}`,
      ],
    })),
  appendTerminal: (line) =>
    set((s) => ({ terminalLines: [...s.terminalLines, line] })),
  clearBuild: () => set({ buildLines: [] }),
  clearLogger: () => set({ loggerLines: [] }),
  clearTerminal: () => set({ terminalLines: [] }),
  setCompiling: (v) => set({ isCompiling: v }),
  setRuntimeReady: (v) => set({ runtimeReady: v }),
  setRuntimeMessage: (msg) => set({ runtimeMessage: msg }),
  resetSession: () =>
    set({
      buildLines: [],
      loggerLines: [],
      terminalLines: [],
      isCompiling: false,
    }),
}));
